module.exports = __webpack_public_path__ + "static/media/groups.138626f1.svg";